<template>
    <b-container class="main_layer py-2" fluid>
        <b-container>
            <b-row>
                <b-col md="9">
                    <router-link class="float-right" :to="{ name: 'CabinetFl44RatingHistory' }">
                        <b-badge v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" class="mt-1 fs-18 mr-2" variant="inverse-green" title="Рейтинг заказчика">
                            Заказчик <b-icon-star-fill />
                            <span class="ml-2">{{ $store.state.organization.customer_rating }}</span>
                        </b-badge>
                        <b-badge class="mt-1 fs-18" variant="inverse-green" title="Рейтинг поставщика">
                            Поставщик <b-icon-star-fill />
                            <span class="ml-2">{{ $store.state.organization.rating }}</span>
                        </b-badge>
                    </router-link>
                    <p class="fs-36 fw-600 white-color mb-1">Личный кабинет</p>
                    <p class="fs-14 greyBg-color mb-2">
                        Наименование организации: <strong>{{ $store.state.organization.short_name }}</strong>
                    </p>
                    <p class="fs-14 greyBg-color mb-2">
                        Пользователь: <strong>{{ $store.state.user.name }}</strong>
                        <span class="pl-5">
                            Логин:
                            <strong>{{ $store.state.user.username }}</strong>
                        </span>
                    </p>
                    <p v-if="features.telegram_bot" class="fs-14 greyBg-color mb-2">
                        ID Пользователя для Telegram / MAX: <strong>{{ $store.state.user.id }}</strong>
                    </p>

                    <b-dropdown variant="custom-white" text="Создать закупку" v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44) || orgRoleIsPermitted($orgRoles.CUSTOMER_FL223) || orgRoleIsPermitted($orgRoles.CUSTOMER_COMMERCIAL)">
                        <b-dropdown-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" :to="{ name: 'Fl44PurchaseCreate' }" link-class="grey-color fs-14">44-ФЗ в ИС (ИМЗ)</b-dropdown-item>
                        <b-dropdown-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" :to="{ name: 'Fl44UnknownVolumePurchaseCreate' }" link-class="grey-color fs-14">44-ФЗ с неопределенным объемом (НМЗ)</b-dropdown-item>
                        <b-dropdown-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" :to="{ name: 'ExternalPurchaseCreate', params: { mode: 'create' } }" link-class="grey-color fs-14">44-ФЗ вне ИС (ВМЗ)</b-dropdown-item>
                        <template v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL223)">
                            <template v-if="$store.state.organization.settings.fl223.allowed">
                                <b-dropdown-item :to="{ name: 'Fl223PurchaseCreate' }" link-class="grey-color fs-14">223-ФЗ</b-dropdown-item>
                            </template>
                            <template v-else>
                                <b-dropdown-item :id="'popover-create-fl223'" link-class="grey-color fs-14">223-ФЗ</b-dropdown-item>
                                <b-popover :target="'popover-create-fl223'" triggers="hover">
                                    <div class="fs-12">
                                        Для создания закупки 223-ФЗ требуется дополнительная информация. Пожалуйста перейдите в
                                        <router-link style="color: var(--green-color); text-decoration: underline" :to="{ name: 'CabinetFl223Settings' }" active-class="" exact-active-class="">настройки</router-link>.
                                    </div>
                                </b-popover>
                            </template>
                        </template>
                        <b-dropdown-item v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_COMMERCIAL)" :to="{ name: 'CommercialPurchaseCreate' }" link-class="grey-color fs-14">Коммерческая</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                <b-col md="3">
                    <div class="text-right mr-2">
                        <b-btn v-if="getCertificateNeedToBeProlonged" :href="$links.prolong_certificate" active-class="" class="text-uppercase my-1 mx-2 w-100" exact-active-class="" target="_blank" variant="custom-danger">Продлить ЭЦП </b-btn>

                        <b-dropdown variant="custom-white" text="Подключить уведомления" right class="text-uppercase my-1 mx-2 w-100">
                            <b-dropdown-item :href="$links.telegram_events_bot" target="_blank" link-class="grey-color fs-14"><svg-icon-tg class="mr-2" />Telegram</b-dropdown-item>
                            <b-dropdown-item :href="$links.max_events_bot" target="_blank" link-class="grey-color fs-14"><svg-icon-max class="mr-2" />MAX</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="$store.state.user.need_to_have_poa && $store.state.user.need_to_upload_poa" class="pt-1 text-center">
                <b-col md="12">
                    <b-button variant="danger" :to="{ name: 'CabinetUserProfile' }" class="fs-14 font-weight-bold w-100">Необходимо загрузить/заменить МЧД на странице: Данные учетной записи</b-button>
                </b-col>
            </b-row>
            <b-row v-if="$store.state.organization.available_fl44_proposal_submission_status.id === 'blocked'" class="pt-1 text-center">
                <b-col md="12">
                    <b-button variant="danger" class="fs-14 font-weight-bold w-100">Подача предложений в закупках 44-ФЗ заблокирована до {{ $store.state.organization.expiration_datetime_blocking_fl44_proposal_submission }}</b-button>
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>
import Config from '@core/js/ddriven/application/config/Config';
import { mapGetters } from 'vuex';
import SvgIconTg from '@/components/elements/svg-icon-tg.vue';
import SvgIconMax from '@/components/elements/svg-icon-max.vue';

export default {
    name: 'cabinet-header',
    components: { SvgIconMax, SvgIconTg },
    computed: {
        ...mapGetters(['getCertificateNeedToBeProlonged']),
        features() {
            return Config.get('theme.features');
        }
    }
};
</script>
<style scoped>
.cabinet_menu li {
    position: relative;
    background: #fff;
    /*border-radius: 4px;*/
}

.cabinet_menu li a {
    border-left: 8px solid transparent;
    font-size: 14px;
    padding: 10px;
    color: var(--grey-color);
}

.cabinet_menu li + li {
    border-top: 1px solid rgba(149, 155, 164, 0.25);
}

.main_layer {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 100px;
}

@media screen and (max-width: 769px) {
}
</style>
<style>
.provider_menu .cabinet_submenu li {
    border-top: none !important;
}

.provider_menu .cabinet_submenu li a {
    font-size: 14px;
    color: var(--grey-color);
}

.provider_menu .cabinet_submenu li a:active {
    background: transparent;
}

.provider_menu .cabinet_submenu li a:hover {
    background: transparent;
}
</style>
